"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PREFIX = '[redux-persistence]';

exports.receivedFunctionalAction = function () {
  return "".concat(PREFIX, " ACTION IGNORED! Actions should be objects") + " with a type property but received a function! Your" + " function resolving middleware (e.g. redux-thunk) must be" + " placed BEFORE redux-storage!";
};

exports.receivedNonObjectAction = function (action) {
  return "".concat(PREFIX, " ACTION IGNORED! Actions should be objects") + " with a type property but received: ".concat(action);
};

exports.missingActionType = function () {
  return "".concat(PREFIX, " ACTION IGNORED! Action objects should have a type property.");
};

exports.defaultErrorHandler = function () {
  return "".concat(PREFIX, " Using default error handler, specify your own using the onError option when creating the middleware");
};